import React from "react";
import { Download } from "lucide-react";
import { fileHref, fileDownloadName } from "../../utils";

export interface DownloadLinkDoc {
  filename?: string;
  fileData?: string;
  serverId?: string;
}

export interface DownloadLinkProps {
  doc: DownloadLinkDoc | null | undefined;
  label?: string;
  size?: number;
  stop?: boolean;
  variant?: string;
}

/* Small download link that renders a real <a download> link. Prefers the
   stored original served by the API ({serverId}), then the {fileData} URL
   for not-yet-synced uploads, then the legacy /documents/ path. */
export function DownloadLink({
  doc,
  label,
  size = 12,
  stop = true,
  variant = "",
}: DownloadLinkProps): JSX.Element | null {
  if (!doc || !doc.filename) return null;
  return (
    <a
      className={"dl " + variant}
      href={fileHref(doc)}
      download={fileDownloadName(doc)}
      title={"Download " + fileDownloadName(doc)}
      aria-label={"Download " + doc.filename}
      onClick={stop ? (e) => e.stopPropagation() : undefined}
    >
      <Download size={size} />
      {label ? <span>{label}</span> : null}
    </a>
  );
}
